export type defType = {
    label: string,
    type: "string" | "date" | "money",
    attribute?: string,
    RPWDataReader?: string,
    check?: boolean,
    dontShowBlank?: boolean,
}

namespace fieldDef {
    export const General: defType[] = [
        { label: "Lawyer", type: "string", attribute: "LawyerName", RPWDataReader: "getLawyerName", check: true },
        { label: "Borrower’s Name", type: "string", attribute: "mortgagors", RPWDataReader: "getMortgagorName" },
        { label: "Property Address", type: "string", attribute: "PropertyAddress", RPWDataReader: "getPropertyAddress" },
        { label: "Trust Bank", type: "string", attribute: "trustBank", RPWDataReader: "getTrustBank", check: true, dontShowBlank: true },
        { label: "Transit Number", type: "string", attribute: "trustTransit", RPWDataReader: "getTransitNumber", check: true, dontShowBlank: true },
        { label: "Trust Account", type: "string", attribute: "trust", RPWDataReader: "getTrustNumber", check: true, dontShowBlank: true },
    ];
    export const Lender: defType[] = [
        { label: "Lender", type: "string", attribute: "Lender" },
        { label: "Branch", type: "string", attribute: "lenderBranch"}
    ];

    export const MortgageInfo: defType[] = [
        { label: "Principal", type: "money", attribute: "Amount" },
        { label: "Type", type: "string", attribute: "LenderMortgageType" },
        { label: "Reference Number", type: "string", attribute: "LenderRefNo" },
        { label: "Advance", type: "money", attribute: "MTGProceeds" },
        { label: "Instruction", type: "date", attribute: "InstructionsDate" },
    ];

    export const ChargeProv: defType[] = [
        { label: "Payment", type: "money", attribute: "PaymentAmount" },
        { label: "First Payment Date", type: "date", attribute: "FirstPaymentDate" },
        { label: "Last Payment Date", type: "date", attribute: "LastPaymentDate" },
        { label: "Interest Adjustment", type: "date", attribute: "InterestAdjustDate" },
        { label: "Interest Rate", type: "string", attribute: "InterestRate" },
        { label: "Calculation Period", type: "string", attribute: "CalculationPeriod" },
        { label: "Payment Date/Frequency", type: "string", attribute: "PaymentDatePeriod" },
        { label: "Balance Due", type: "date", attribute: "MaturityDate" },
    ];
}

export default fieldDef;